import isEmpty from 'lodash/isEmpty';

const isProductInactive = ({ product }) => !isEmpty(product) && product.isActive === 'N';

const main = {
  title: ({ product, product: { brand, productName } }) => {
    if (isProductInactive(product)) {
      return `Buy ${brand} ${productName} now at italist and save up to 40%. EXPRESS international shipping! Similar products also available.`;
    }

    return 'italist, ALWAYS LIKE A SALE';
  },
  description: () =>
    'Over 200,000 current fashion products, up to 40% cheaper, express shipped from the best Italian boutiques. Shop 1,000 worldwide luxury designer brands',
};

export default main;
